import { __assign } from "tslib";
import $i18n from 'panda-i18n';
import React from 'react';
import { CnDatePickerPro, } from '@/components/cn-date-picker-pro';
var CnMonthPickerPro = function (props) {
    return (React.createElement(CnDatePickerPro, __assign({ precision: "month", placeholder: $i18n.get({
            id: 'PleaseSelectTheMonth',
            dm: '请选择月',
            ns: 'CnDatePickerPro',
        }), format: $i18n.get({
            id: 'YYYYYearMMMonth',
            dm: 'YYYY年-MM月',
            ns: 'CnDatePickerPro',
        }) }, props)));
};
export { CnMonthPickerPro };
